module.exports = __webpack_public_path__ + "img/modular-coding-dark.54d791b4.svg";